(function () {

  function cleanText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function upgradeTerkProduct() {
    const productPage = document;
    if (!productPage) return;

    const terkPanel = productPage.querySelector('[data-terk-set-panel]');
    if (!terkPanel) return;

    // Rename option headings
    productPage
      .querySelectorAll('.product-form__input .form__label')
      .forEach(function (label) {
        const text = cleanText(label.textContent);

        if (text.includes('TERK Scrub Top')) {
          label.childNodes.forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE) {
              node.textContent = 'TOP SIZE ';
            }
          });
        }

        if (text.includes('TERK Scrub Pants')) {
          label.childNodes.forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE) {
              node.textContent = 'PANT SIZE ';
            }
          });
        }
      });

    // Visually change XXL to 2XL
    productPage
      .querySelectorAll('.product-form__input input[type="radio"] + label')
      .forEach(function (label) {
        if (cleanText(label.textContent) === 'XXL') {
          label.textContent = '2XL';
        }
      });

    // Change Add to cart wording
    productPage
      .querySelectorAll('.product-form__submit')
      .forEach(function (button) {
        const span = button.querySelector('span');
        const target = span || button;

        if (
          cleanText(target.textContent)
            .toLowerCase()
            .includes('add to cart')
        ) {
          target.textContent = 'ADD SET TO BAG · $75';
        }
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    upgradeTerkProduct();

    setTimeout(upgradeTerkProduct, 300);
    setTimeout(upgradeTerkProduct, 1000);
  });

  document.addEventListener('shopify:section:load', upgradeTerkProduct);

  const observer = new MutationObserver(function () {
    upgradeTerkProduct();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();